import styled from 'styled-components';

import {
  Table as SemanticTable,
} from 'semantic-ui-react';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

const Table = styled(SemanticTable)``;

const Row = styled(Table.Row)``;

const Column = styled(Table.Cell)`
  min-width: 135px;
  height: 42px;
`;

const HeaderColumn = styled(Table.HeaderCell)`
  min-width: 135px;
`;

const Header = styled(Table.Header)``;

const Body = styled(Table.Body)``;

const Text = styled(TextLayoutComponent)``;

const StyledText = styled(TextLayoutComponent)`
  margin-right: 10px !important;
`;

const Link = styled.a`
  color: #ff0000;
`;

const Container = styled.div`
    overflow: auto;
`;

const ProjectNameWrapper = styled.div`
   display: flex;
   justify-content: flex-start;
`;

export {
  Table,
  Row,
  HeaderColumn,
  Text,
  Header,
  Column,
  Body,
  Container,
  Link,
  ProjectNameWrapper,
  StyledText,
};
